import { render, staticRenderFns } from "./ProductSpecsElementEdit.vue?vue&type=template&id=b7f6967e"
import script from "./ProductSpecsElementEdit.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f6967e')) {
      api.createRecord('b7f6967e', component.options)
    } else {
      api.reload('b7f6967e', component.options)
    }
    module.hot.accept("./ProductSpecsElementEdit.vue?vue&type=template&id=b7f6967e", function () {
      api.rerender('b7f6967e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecsElement/ProductSpecsElementEdit.vue"
export default component.exports